import { Shield, Github, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-800 bg-[#08090f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 rounded-md bg-gradient-to-br from-cyan-400 to-cyan-600 flex items-center justify-center">
                <Shield className="w-4 h-4 text-slate-950" strokeWidth={2.75} fill="currentColor" />
              </div>
              <span className="font-display font-bold text-lg">The Good Guys<span className="text-cyan-signal">.</span></span>
            </div>
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
              We're the good guys. Every phone, email and IP signal your team needs to spot the bad ones — in under 300ms.
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" data-testid="footer-social-twitter" className="w-9 h-9 flex items-center justify-center rounded-md border border-slate-800 text-slate-400 hover:text-cyan-signal hover:border-cyan-signal/40 transition-colors"><Twitter className="w-4 h-4" /></a>
              <a href="#" data-testid="footer-social-github" className="w-9 h-9 flex items-center justify-center rounded-md border border-slate-800 text-slate-400 hover:text-cyan-signal hover:border-cyan-signal/40 transition-colors"><Github className="w-4 h-4" /></a>
            </div>
          </div>

          <FooterCol title="Product" items={[
            ["Phone Validation", "/console"],
            ["Email Verify", "/console"],
            ["IP Intelligence", "/console"],
            ["Bulk CSV", "/dashboard"],
            ["Free Tools", "/tools"],
          ]} />
          <FooterCol title="Developers" items={[
            ["REST API Docs", "/docs"],
            ["MCP Connector", "/docs"],
            ["Pricing", "/pricing"],
            ["Status", "#"],
          ]} />
          <FooterCol title="Company" items={[
            ["About", "#"],
            ["Compliance", "#"],
            ["Contact", "#"],
            ["Privacy", "#"],
          ]} />
        </div>

        <div className="mt-12 pt-6 border-t border-slate-900 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-mono text-slate-500">© 2026 THE GOOD GUYS LABS · WATCHING THE BAD ONES</p>
          <p className="text-xs font-mono text-slate-500">SOC 2 · GDPR · ISO 27001</p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <h4 className="text-xs font-mono uppercase tracking-widest text-slate-500 mb-4">{title}</h4>
      <ul className="space-y-2">
        {items.map(([label, to]) => (
          <li key={label}>
            <Link to={to} className="text-sm text-slate-400 hover:text-cyan-signal transition-colors">{label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
